import TranslationsTable from 'components/Translations/TranslationsTable';
import useActions from 'hooks/useActions';
import { useEffect } from 'react';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        answer: state.CSAnswers.selectedAnswer,
        translations: state.CSAnswers.translations,
        page: state.CSAnswers.translations_page,
        per_page: state.CSAnswers.translations_per_page,
        total: state.CSAnswers.translations_total,
        total_pages: state.CSAnswers.translations_total_pages,
        isLoading: state.CSAnswers.translations_is_loading,
        selectedTranslation: state.CSAnswers.selectedTranslation,
    };
}

const CSAnswerTranslations = connect(mapStateToProps)(function (props) {
    const {
        answer,
        translations,
        page,
        per_page,
        total,
        total_pages,
        isLoading,
        selectedTranslation,
    } = props;

    const {
        CS_FETCH_ANSWER_TRANSLATIONS_REQUEST,
        CS_POST_ANSWER_TRANSLATION_REQUEST,
        CS_UPDATE_ANSWER_TRANSLATION_REQUEST,
        CS_DELETE_ANSWER_TRANSLATION_REQUEST,
        CS_SELECT_ANSWER_TRANSLATION,
    } = useActions();

    function onNext() {
        CS_FETCH_ANSWER_TRANSLATIONS_REQUEST({
            answerId: answer?.id,
            page: page + 1,
            per_page,
        });
    }

    function onPrev() {
        CS_FETCH_ANSWER_TRANSLATIONS_REQUEST({
            answerId: answer?.id,
            page: page - 1,
            per_page,
        });
    }

    function onPageSelected(selectedPage) {
        CS_FETCH_ANSWER_TRANSLATIONS_REQUEST({
            answerId: answer?.id,
            page: selectedPage,
            per_page,
        });
    }

    function onPerPageSelected({ perPage }) {
        CS_FETCH_ANSWER_TRANSLATIONS_REQUEST({
            answerId: answer?.id,
            per_page: perPage,
        });
    }

    function onDelete(translation) {
        CS_DELETE_ANSWER_TRANSLATION_REQUEST({
            answerId: answer?.id,
            page,
            per_page,
            translationId: translation.id,
        });
    }

    function onUpdate(translation) {
        CS_UPDATE_ANSWER_TRANSLATION_REQUEST(translation);
    }

    function onCreate(translation) {
        CS_POST_ANSWER_TRANSLATION_REQUEST({
            resourceId: answer?.id,
            translation,
        });
    }

    useEffect(() => {
        CS_FETCH_ANSWER_TRANSLATIONS_REQUEST({
            answerId: answer?.id,
        });
        return () => {
            CS_SELECT_ANSWER_TRANSLATION(null);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <TranslationsTable
            page={page}
            perPage={per_page}
            onNext={onNext}
            onPrev={onPrev}
            onPageSelected={onPageSelected}
            onPerPageSelected={onPerPageSelected}
            isLoading={isLoading}
            total={total}
            totalPages={total_pages}
            onDelete={onDelete}
            translations={translations}
            onSelect={CS_SELECT_ANSWER_TRANSLATION}
            onCreate={onCreate}
            onUpdate={onUpdate}
            selectedTranslation={selectedTranslation}
        />
    );
});

export default CSAnswerTranslations;
